import { useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { CATALOG_CATEGORIES } from "@/data/catalog";
import { call, errText } from "@/lib/api";

const DECADES = [1980, 1990, 2000, 2010, 2020];
const wait = (ms) => new Promise((r) => setTimeout(r, ms));

const pollJob = async (id) => {
  for (let i = 0; i < 80; i += 1) {
    await wait(3000);
    const res = await call(`/admin/catalog/ai-jobs/${id}`);
    const job = await res.json().catch(() => null);
    if (job?.status && job.status !== "running") return job;
  }
  return { status: "error", error: "La IA tardó demasiado. Revisa el catálogo en unos minutos." };
};

export const AiExpand = ({ onDone }) => {
  const [v, setV] = useState({ category: "figuras", manufacturer: "", decade: "", count: 10 });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setV((s) => ({ ...s, [k]: e.target.value }));
  const run = async () => {
    setBusy(true);
    const body = { category: v.category, count: Number(v.count), ...(v.manufacturer.trim() && { manufacturer: v.manufacturer.trim() }), ...(v.decade && { decade: Number(v.decade) }) };
    const res = await call("/admin/catalog/ai-expand", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) { setBusy(false); return toast.error(errText(data?.detail)); }
    const job = await pollJob(data.job_id);
    setBusy(false);
    if (job.status === "done") toast.success(`La IA agregó ${job.count} pieza${job.count === 1 ? "" : "s"} nuevas.`, { description: "Revísalas: pueden tener errores." });
    else toast.error(job.error || "No se pudo completar.");
    onDone();
  };
  return (
    <div className="rounded-2xl border border-[rgba(123,199,77,0.35)] bg-[rgba(123,199,77,0.06)] p-5" data-testid="ai-expand-panel">
      <p className="flex items-center gap-2 font-display text-2xl"><Sparkles size={18} className="text-[var(--green)]" /> Ampliar con IA</p>
      <p className="mt-1 text-sm text-[var(--muted)]">Claude propone piezas oficiales que aún no están en el catálogo. Pueden tener errores en fechas o versiones: revísalas y edítalas.</p>
      <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-[1fr_1fr_140px_110px_auto]">
        <select value={v.category} onChange={set("category")} className="support-input" data-testid="ai-category-select">
          {CATALOG_CATEGORIES.map((c) => <option key={c.id} value={c.id}>{c.label}</option>)}
        </select>
        <input value={v.manufacturer} onChange={set("manufacturer")} placeholder="Marca (opcional), ej. NECA" className="support-input" data-testid="ai-manufacturer-input" />
        <select value={v.decade} onChange={set("decade")} className="support-input" data-testid="ai-decade-select">
          <option value="">Cualquier década</option>
          {DECADES.map((d) => <option key={d} value={d}>{String(d).slice(2)}'s</option>)}
        </select>
        <select value={v.count} onChange={set("count")} className="support-input" data-testid="ai-count-select">
          {[5, 10, 20].map((n) => <option key={n} value={n}>{n} piezas</option>)}
        </select>
        <button type="button" onClick={run} disabled={busy} className="btn-primary justify-center" data-testid="ai-expand-btn">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <Sparkles size={16} />} {busy ? "Generando…" : "Generar"}
        </button>
      </div>
      {busy && <p className="mono mt-3 text-[11px] text-[var(--green)]" data-testid="ai-expand-progress">La IA está investigando. Puede tardar hasta un par de minutos.</p>}
    </div>
  );
};
